import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/Login';
import ParentMain from '@/views/ParentMain';
import store from '../store';
import PageTransition from '@/components/PageTransition';
import MyClass from '@/views/MyClass';
import MyRecord from '@/views/MyRecord';
import MyNew from '@/views/Myrecord/MyNew';
import TecComment from '@/views/Myrecord/TecComment';
import AboutCourse from '@/views/Myrecord/AboutCourse';
import CompletedCourse from '@/views/Myrecord/CompletedCourse';
import MyPhone from '@/views/Myrecord/MyPhoto';
// import PostMsg from '@/views/PostMsg';
import Setting from '@/views/setting';
import AboutUs from '@/views/aboutUs';
import CourseDetail from '@/views/Myrecord/courseDetail';
import PictureView from '@/views/PictureView';
import TeacherMain from '@/views/TeacherMain';
import Work from '@/views/Work';
import TeacherInfo from '@/views/TeacherInfo';
import StudentCheckIn from '@/views/StudentCheckIn';
import StudentList from '@/views/StudentList';
import StudentProfileInfo from '@/views/StudentProfileInfo';
import Attendance from '@/views/Attendance';
import Loading from '@/views/Loading';

import signature from '@/views/signature';
import UpImage from '@/views/UpImage';
import localStorage from '../localstorage/localStorage';

Router.prototype.goBack = function () {
  this.isBack = true;
  window.history.go(-1);
};
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      component: PageTransition,
      children: [
        {
          path: '',
          name: 'Loading',
          component: Loading
        },
        {
          path: '/login',
          name: 'Login',
          component: Login,
          beforeEnter (to, from, next) {
            if (store.state.userInfo.user) {
              if (store.state.userInfo.user.roleId === 7) {
                next({path: '/parent-main'});
              } else{
                next({path: '/teacher-main'});
              }
            } else {
              next();
            }
          }
        },
        {
          path: '/parent-main',
          name: 'parent-main',
          component: ParentMain,
          redirect: '/class',
          children: [
            {
              name: 'myClass',
              path: '/class',
              component: MyClass,
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/record',
              component: MyRecord,
              meta: {
                requireAuth: true
              }
            }
          ],
          meta: {
            requireAuth: true
          }
        },
        {
          path:'/signature/:id/:signStatus/:isCustom',
          name: 'signature',
          component: signature,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/record-new',
          name: 'record-new',
          component: MyNew,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/record-TecComment',
          name: 'record-TecComment',
          component: TecComment,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/record-aboutCourse',
          name: 'record-aboutCourse',
          component: AboutCourse,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/record-completedCourse',
          name: 'record-completedCourse',
          component: CompletedCourse
        },
        {
          path: '/record-completedCourse-detail',
          name: 'record-completedCourse-detail',
          component: CourseDetail
        },
        {
          path: '/record-photo',
          name: 'record-photo',
          component: MyPhone
        },
        // {
        //   path: '/post-msg',
        //   name: 'PostMsg',
        //   component: PostMsg,
        //   meta: {
        //     requireAuth: true
        //   }
        // },
        {
          path: '/record/setting',
          name: '/record/setting',
          component: Setting
        },
        {
          path: '/aboutUs',
          name: '/aboutUs',
          component: AboutUs
        },
        {
          path: '/picture-view',
          name: '/pictureView',
          component: PictureView
        },
        {
          path: '/teacher-main',
          name: '/teacherMain',
          component: TeacherMain,
          redirect: '/work',
          children: [
            {
              path: '/work',
              name: 'work',
              component: Work
            },
            {
              path: '/my-class',
              name: 'my-class',
              component: MyClass
            },
            {
              path: '/teacher-info',
              name: 'teacher-info',
              component: TeacherInfo
            }
          ]
        },
        {
          path: '/UpImage',
          name: 'UpImage',
          component: UpImage
        },
        {
          path: '/student-check-in',
          name: 'studentCheckIn',
          component: StudentCheckIn
        },
        {
          path: '/attendance',
          name: 'attendance',
          component: Attendance
        },
        {
          path: '/student-list',
          name: 'studentList',
          component: StudentList
        },
        {
          path: '/student-profile',
          name: 'studentProfileInfo',
          component: StudentProfileInfo
        }
      ]
    }
  ],
  linkActiveClass: ['u-link--Active1', 'u-link--Active2', 'u-link--Active3']
});
//全局前置路由守卫  初始化时被调用、切换路由前被调用
router.beforeEach((to,from,next)=>{
  //获取token
  const token = localStorage.getData('token');
  if(!token){
    //如果有token则判断登入页面
    if(to.path!=='/login'){
        next({path: '/login'});
    }
  }
  next()
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js